import DossierType from '@/assets/enums/dossier/DossierType'

const baseInformationsConfig = {
  informations: true,
  deceased: true,
  civil_information: true,
  profession: true,
  marital_status: true,
  parent: true,
  children: true,
  death: true,
  other: true,
  cemetery: false,
  partners: true
}
const baseFuneralsConfig = {
  funeralInfos: true,
  declaration: true,
  cremation: true,
  crematorium_arrival: true,
  ceremony: true,
  wake: true,
  burial: true,
  body_raising: true,
  ashes_recovery: true,
  reunion: true,
  visit: true,
  room_occupancy: true,
  reception: true,
  exhumation: false,
  marbrerie: true,
  appointment: false
}
const baseRemainsConfig = {
  transfert: true,
  thanato: true,
  pacemaker: true,
  coffin_placing: true,
  coffin_closing: true,
  sealing_process: true,
  other_infos: true
}

let config = Object.freeze({
  [DossierType.DECES]: {
    informations: {
      ...baseInformationsConfig
    },
    funerals: {
      ...baseFuneralsConfig,
      marbrerie: true
    },
    remains: {
      ...baseRemainsConfig
    },
    contacts: null,
    coffin_and_products: null,
    particularities: null,
    other_products: null,
    flowers: null,
    printings: null,
    external_services: null,
    other_events: null,
    condolences: null,
    financing: null
  },
  [DossierType.CONTRAT]: {
    informations: {
      ...baseInformationsConfig
    },
    funerals: {
      ...baseFuneralsConfig,
      marbrerie: true
    },
    remains: {
      ...baseRemainsConfig
    },
    contacts: null,
    coffin_and_products: null,
    particularities: null,
    other_products: null,
    external_services: null,
    flowers: null,
    printings: null,
    other_events: null,
    condolences: null,
    financing: null
  },
  [DossierType.DEMARCHE]: {
    informations: {
      ...baseInformationsConfig
    },
    funerals: {
      ...baseFuneralsConfig,
      marbrerie: true
    },
    remains: {
      ...baseRemainsConfig
    },
    contacts: null,
    coffin_and_products: null,
    particularities: null,
    other_products: null,
    flowers: null,
    printings: null,
    external_services: null,
    other_events: null,
    condolences: null,
    financing: null
  },
  [DossierType.RAPATRIEMENT]: {
    informations: {
      ...baseInformationsConfig
    },
    funerals: {
      ...baseFuneralsConfig
    },
    remains: {
      ...baseRemainsConfig
    },
    contacts: null,
    coffin_and_products: null,
    particularities: null,
    other_products: null,
    flowers: null,
    printings: null,
    external_services: null,
    other_events: null,
    condolences: null,
    financing: null
  },
  [DossierType.EXHUMATION]: {
    informations: {
      ...baseInformationsConfig
    },
    funerals: {
      ...baseFuneralsConfig,
      exhumation: true,
      marbrerie: true
    },
    remains: {
      ...baseRemainsConfig
    },
    contacts: null,
    coffin_and_products: null,
    particularities: null,
    other_products: null,
    external_services: null,
    flowers: null,
    printings: null,
    other_events: null,
    condolences: null,
    financing: null
  },
  [DossierType.MARBRERIE]: {
    informations: {
      ...baseInformationsConfig,
      profession: false,
      marital_status: false,
      parent: false,
      children: false,
      death: true,
      other: false,
      cemetery: true,
      partners: true
    },
    funerals: {
      ...baseFuneralsConfig,
      funeralInfos: false,
      appointment: true,
      declaration: false,
      cremation: false,
      crematorium_arrival: true,
      burial: false,
      ceremony: false,
      wake: false,
      body_raising: false,
      ashes_recovery: false,
      reunion: false,
      visit: false,
      room_occupancy: false,
      reception: false,
      exhumation: false,
      marbrerie: true
    },
    contacts: null,
    // coffin_and_products: null,
    particularities: null,
    other_products: null,
    // external_services: null,
    // other_events: null,
    financing: null
  }
})

/**
 * @param {string} type
 * @param {string} section
 * @returns {boolean}
 */
export let hasSection = (type, section) => {
  return config.hasOwnProperty(type) && config[type].hasOwnProperty(section)
}

/**
 * @param {string} type
 * @param {string} section
 * @param {string} subSection
 * @returns {boolean}
 */
export let hasSubSection = (type, section, subSection) => {
  if (!hasSection(type, section)) return false
  const sectionConfig = config[type][section]
  if (sectionConfig === null) return true
  return (
    sectionConfig.hasOwnProperty(subSection) &&
    sectionConfig[subSection] === true
  )
}

export default config
